import React from 'react';
import {MasterLayout} from 'layout';
import {browserHistory} from 'react-router';
import {ListGiaiQuyetDon} from "modules/giai-quyet-don";
import cookie from 'react-cookie';
import {checkServerLive} from 'constants/config';
import {Danhmuc} from 'api';

export default class GiaiQuyetDonPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataThamSo: []
    }
  }

  componentWillMount() {
    if (typeof cookie.load('accessToken') === 'undefined') {
      browserHistory.push('/dang-nhap');
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
          <ListGiaiQuyetDon/>
      </MasterLayout>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/giai-quyet-don/GiaiQuyetDonPage.jsx